var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("p", [
      _vm._v("Сумма в заявке "),
      _c("strong", [_vm._v(_vm._s(_vm.order.price))]),
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v("Реквизиты привязаны к заявке на сумму "),
      _c("strong", [_vm._v(_vm._s(_vm.order.no_cash_price))]),
    ]),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert alert-info" }, [
      _c("p", [
        _vm._v(
          "Заявка закрыта за наличные, но есть реквизиты к оплате по б/н и привязаны оплаты"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("Рекомендации")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v("отвязать оплату, если она не принадлежит этой заявке"),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("выяснить как закрыта заявка, за наличные или по б/н"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }